/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */



/* eslint-disable no-console */
import React, { Suspense, useMemo } from 'react';
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import {
  CalendarNav,
  CalendarNext,
  CalendarPrev,
  CalendarToday,
  Eventcalendar,
  MbscCalendarDayData,
  MbscCalendarEvent,
  MbscCalendarEventData,
  MbscCellClickEvent,
  MbscEventcalendarView,
  MbscEventClickEvent,
  MbscEventCreateEvent,
  MbscEventDragEvent,
  MbscResource,
  MbscSelectedDateChangeEvent,
  Segmented,
  SegmentedGroup,
  setOptions,
} from '@mobiscroll/react';
import { ChangeEvent, FC, useCallback, useEffect, useState } from 'react';
import './Calendar.css';
import { Avatar, Box, Button, ButtonGroup, Chip, Divider, IconButton, Menu, MenuItem, Stack, styled, Tooltip, tooltipClasses, TooltipProps, Typography } from '@mui/material';
import ListIcon from '@mui/icons-material/List';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';
import HorizontalAvatarList from '../avatarListComponent';
import { cancelAppointmentOOO, departmentsByClinic, getAppointments, getAppointmentsOOO, getUsersByClinic, updateAppointmentDate } from '../../services/apiService';
import { Appointment, CustomMbscEvent, DepartmentDetail, UserBasic } from '../../types';
import { useAlert } from '../alertProvider';
import { useLoader } from '../loaderProvider/loader';
import WorkOffIcon from '@mui/icons-material/WorkOff';
import AppointmentTable from '../AppointmentTable/appointmentTable';
import '../../custom-mobiscroll-theme.scss';
import AppointmentModal from '../appointmentForm/appointmentForm';
import { EventcalendarBase } from '@mobiscroll/react/dist/src/core/components/eventcalendar/eventcalendar';
import { convertToLocalDateTime, formatDateToDDMMYYYY, formatDateToLocalYYYYMMDD } from '../../services/time';
import CustomModal from '../appointmentViewModal';
import { useClinic } from '../ClinicProvider';
import OutOfOfficeForm from './outOfOfficeForm';
import { getDepartmentColor, getEventBgColor, getStatusColor, isDateInPast, scheduleFilters, toTitleCase } from '../../utils/commonUtils';
import { getStatus, Status } from './Calendar.helper';
import {ReactComponent as SendBackIcon} from '../../assets/SVG/send-Back.svg';
import { useVerboseLog } from '../../utils/debug';

// import AppointmentTable from '../AppointmentTable/appointmentTable';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};


setOptions({
  theme: 'ios',
  themeVariant: 'light',
  accent: 'Orange'
});

const CalendarComponent: FC = () => {

  const verboseLog = useVerboseLog();

  const [view, setView] = useState('month');
  const [resource, setResource] = useState<MbscResource[] | undefined>();
  const [myEvents, setEvents] = useState<MbscCalendarEvent[]>([]);
  const [calView, setCalView] = useState<MbscEventcalendarView | undefined>(undefined);
  const [menuPosition, setMenuPosition] = useState<{ mouseX: number; mouseY: number } | null>(null);
  const [clickedEvent, setClickedEvent] = useState<MbscCalendarEvent | null>(null);
  const [useTimeline, setUseTimeline] = React.useState(true);
  const [tabValue, setTabValue] = useState<DepartmentDetail>();
  const [currentView, setCurrentView] = useState<'CALENDAR' | 'TABLE'>('CALENDAR');
  const [appointments, setAppointments] = useState<Appointment[] | undefined>();
  const [departmentList, setDepartmentList] = useState<DepartmentDetail[]>([]);
  const [showOutofOfficeForm, setShowOutofOfficeForm] =  useState<boolean>(false);
  const [oooEvents, setOooEvents] = useState<MbscCalendarEvent[]>([]);
  const [status, setStatus] = useState<Status[] | null>();
  const [viewDateFrom, setViewDateFrom] = useState<Date | null>();
  const [viewDateTo, setViewDateTo] = useState<Date | null>();
  const [filterAppointments, setFilterAppointments ] = useState<string | undefined>(undefined);
  const [filterAppointmentsScheduled, setFilterAppointmentsScheduled ] = useState<string | undefined>(undefined);
  const [initialLoad, setInitialLoad ] = useState<boolean>(true);

  const handlePageLoad = useCallback((args: any) => {
    if (viewDateFrom?.toISOString() !== args.firstDay.toISOString() ||
    viewDateTo?.toISOString() !== args.lastDay.toISOString()) {
      setViewDateFrom(args.firstDay);
      setViewDateTo(args.lastDay);
    }
    console.log(viewDateFrom, viewDateTo);
  }, [viewDateFrom, viewDateTo]);
    
  const handleClosehowOutofOfficeFormModel = () => {
    setShowOutofOfficeForm(false);
    setModelStateUpdate(!modelStateUpdate);
  };
  const {addAlert} = useAlert();
  const { showLoader, hideLoader } = useLoader();
  const { ClinicId } = useClinic();

  const [openViewModel, setOpenViewModel] = React.useState(false);
  const handleOpenViewModel = () => setOpenViewModel(true);
  const handleCloseViewModel = () => {
    setOpenViewModel(false);
    setViewEvent(undefined);
    setModelStateUpdate(!modelStateUpdate);
  };
  const [viewEvent, setViewEvent] = React.useState<MbscEventClickEvent | undefined>(undefined);

  const [openCreateModel, setOpenCreateModel] = React.useState(false);

  // const handleOpenCreateModel = () => setOpenCreateModel(true);
  /**
   * Opens the create event modal if the end date is in the future.
   *
   * @param event - The event object containing start and end dates.
   *
   * If the end date is in the past, an alert is shown, and the modal won't open.
   **/
  const handleOpenCreateModel = (event: MbscEventCreateEvent) => {
    const selectedDate = event.event.end as Date;

    if (isDateInPast(selectedDate)) {
      setCreateEvent(undefined);

      setModelStateUpdate(!modelStateUpdate);
      addAlert('Oops! Please select a future date for book appointment.', 'info');
      return;
    }
    setOpenCreateModel(true);
  };


  const handleOpenCreateModelSC = (event: MbscCellClickEvent) => {
    const selectedDate = event.date as Date;

    if (isDateInPast(selectedDate)) {
      setCreateEvent(undefined);

      setModelStateUpdate(!modelStateUpdate);
      addAlert('Oops! Please select a future date for book appointment.', 'info');
      return;
    }
    setOpenCreateModel(true);
  };


  const handleCloseCreateModel = () => {
    setCreateEventSC(undefined);
    setCreateEvent(undefined);
    setOpenCreateModel(false);
    setModelStateUpdate(!modelStateUpdate);
  };
  const [createEvent, setCreateEvent] = React.useState<MbscEventCreateEvent | undefined>(undefined);
  const [createEventSC, setCreateEventSC] = React.useState<MbscCellClickEvent | undefined>(undefined);
  const [users, setUsers] = React.useState<UserBasic[] | undefined>(undefined);
  const [selectedDoctor, setSelectedDoctor] = React.useState<number[]>([]);
  const [query, setQuery] = React.useState<string |  undefined>(undefined);
  const [modelStateUpdate, setModelStateUpdate] = useState(false);
  const departmentFilters = ['Admin', 'Pathology', 'Semen Collection'];
  const docFilters = ['Consultation', 'Ultrasound', 'Surgery'];
  const [selectedDate, setSelectedDate] = useState<string | null>();



  useEffect(() => {

    if (ClinicId) {
      departmentsByClinic(ClinicId).then((response) => setDepartmentList(response.objects))
        .catch(() => addAlert('Failed to fetch departments', 'error'));
    }
  }, [ClinicId, addAlert]);


  useEffect(() => {
    setSelectedDoctor([]);
  }, [tabValue]);

  useEffect(() => {
    departmentList.map((department: DepartmentDetail) => {
      if (department.name === 'Admin') {
        setTabValue(department);
      }
      return department;
    });
  }, [departmentList]);

  useEffect(() => {
    let limit = '100';
    if (view === 'month') {
      limit = '1000';
    } else if (view === 'week') {
      limit = '500';
    } else {
      limit = '100';
    }
    if (tabValue && (view !== 'timeline')) {
      const query = `limit=${limit}&order_by=end_datetime&department__id=${tabValue?.id}`;
      setQuery(query);
    
      getUsersByClinic(ClinicId, tabValue?.id.toString()).then((userRes) => setUsers(userRes.objects));
    }
    // eslint-disable-next-line 
  }, [tabValue, ClinicId]);

  useEffect(() => {
    let limit = '100';
    if (view === 'month') {
      limit = '1000';
    } else if (view === 'week') {
      limit = '500';
    } else {
      limit = '100';
    }
    if (view === 'timeline') {
      setUsers([]);
      const query = `limit=${limit}&order_by=end_datetime&role=DOCTOR`;
      setQuery(query);
      getUsersByClinic(ClinicId, null, 'DOCTOR').then((userRes) => setUsers(userRes.objects));
    }
  }, [view, ClinicId, tabValue?.id]);

  useEffect(() => {
    let limit = '100';
    if (view === 'month') {
      limit = '1000';
    } else if (view === 'week') {
      limit = '500';
    } else {
      limit = '100';
    }
    if (tabValue?.id  && (view !== 'timeline')) {
      if (selectedDoctor.length > 0) {
        setQuery(`limit=${limit}&order_by=end_datetime&department__id=${tabValue?.id}&user__id__in=${selectedDoctor.join(',')}`);
      } else {
        setQuery(`limit=${limit}&department__id=${tabValue?.id}&order_by=end_datetime`);
      }
    }
  }, [selectedDoctor, tabValue?.id, view]);

  // Query update for appointments filters

  useEffect(()=> {
    const myResources: MbscResource[] | undefined = users?.map((user: UserBasic) =>({
      id: user.id,
      name: `${user.first_name} ${user.last_name}`,
    }));
    if (myResources) {
      const unoqueResources = Array.from(
        new Map(myResources.map((resource) => [resource.id, resource])).values()
      );
      setResource(unoqueResources);
    }
  }, [users]);


  // Handle right-click event
  const handleEventRightClick = (args: MbscEventClickEvent) => {
    if (!args.event.title?.includes('Out of Office')) {
      return;
    }
    args.domEvent.preventDefault();  // Prevent the default context menu
    setClickedEvent(args.event);  // Set the clicked event
    // Set the menu position at the cursor location
    setMenuPosition({
      mouseX: args.domEvent.clientX,
      mouseY: args.domEvent.clientY
    });
  };

  // Close the Material-UI menu
  const closeMenu = () => {
    setMenuPosition(null);
  };

  useEffect(() => {
    if (view === 'timeline') {
      setSelectedDoctor([]);
      setUseTimeline(true);
    } else {
      setUseTimeline(false);
    }
  }, [view]);

  // Handle calendar view change
  const changeView = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    let calView = {};
    switch (event.target.value) {
    case 'month':
      calView = { calendar: { labels: true } };
      break;
    case 'week':
      calView = { schedule: { type: 'week', maxEventStack: 1 } };
      break;
    case 'day':
      calView = { schedule: { type: 'day', timeCellStep: 15, maxEventStack: 4 } };
      break;
    case 'timeline':
      calView = {
        timeline: {
          type: 'day',
          timeCellStep: 15,
        }
      };
      break;
    }
    setView(event.target.value);
    setCalView(calView);
  } , []);

  const avatars = useMemo(() => {
    return users?.map((user: UserBasic) => ({
      id: user.id,
      name: `${user.first_name}`,
      src: '',
      selected: selectedDoctor?.includes(user.id)
    }));
  }, [users, selectedDoctor]);

  const stringToColor = (name: string) => {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const color = `#${((hash >> 24) & 0xFF).toString(16)}${((hash >> 16) & 0xFF).toString(16)}${((hash >> 8) & 0xFF).toString(16)}`.slice(0, 7);
    return color;
  };

  const renderCustomResource = (resource: MbscResource) => (
    <div className='cal-res-ava'>
      {resource && resource.name && <Avatar
        alt={resource.name}
        src={resource.img}
        sx={{
          width: 50,
          height: 50,
          ...(typeof(resource.id) === 'number' && {bgcolor: numberToColorHash(resource.id)}), // Background color if no image
          fontSize: '0.8rem' // Smaller font for the initials
        }}
      >
        {!resource.img && resource.name[0]} {/* Display first letter if no image */}
      </Avatar>
      }
      <div className="resource-name">{resource.name}</div></div>
  );

  const renderEvent = (resource: MbscCalendarEventData) => {
    if (resource.title?.split('--')[1] === 'CANCELLED') {
      return <div className='cal-event-label cal-event-cancel'>
        {`${resource.title?.split('--')[0]}`}
      </div>;
    }
    return ( <div className='cal-event-label'>
      {resource.title?.split('--')[0]}
    </div>);
  };

  const handleAvatarSelection = useCallback((id: number) => {
    if ((id < 0 || selectedDoctor?.includes(id)) && selectedDoctor) {
      setSelectedDoctor(selectedDoctor.filter(userId => userId !== id));
      return;
    }
    setSelectedDoctor([...selectedDoctor, id]);
  }, [selectedDoctor]);

  // Custom header with navigation buttons
  const customWithNavButtons = useCallback(
    () => (
      <div className='cal-container'>
        <div className='cal-ftr'>
          {!useTimeline && (tabValue?.name === 'Surgery' || tabValue?.name === 'Ultrasound' || tabValue?.name === 'Consultation') && avatars && <HorizontalAvatarList avatars={avatars} maxWidth={1000} onClick={handleAvatarSelection}/>}
          {view === 'timeline' && (tabValue?.name === 'Surgery' || tabValue?.name === 'Ultrasound' || tabValue?.name === 'Consultation') && 
            <IconButton onClick={()=>{
              setView('month');
              setCalView({ calendar: { labels: true } });
              setTabValue(departmentList.find((department:DepartmentDetail)=>department.name === 'Admin'));
            }}
            disableFocusRipple
            disableTouchRipple
            >              
              <Typography variant='caption' color="primary.main" fontSize={'16px'} fontWeight={'600'}><SendBackIcon/>Go Back</Typography>
            </IconButton>
          }
        </div>
        <div className='cal-nav'>
          <CalendarNav className="cal-header-nav"/>
          <div className="cal-header-picker">
            <SegmentedGroup value={view} onChange={changeView}>
              <Segmented value="day">Day</Segmented>
              <Segmented value="week">Week</Segmented>
              <Segmented value="month">Month</Segmented>
              {/* {(tabValue?.name === 'Consultation' || tabValue?.name === 'Surgery' || tabValue?.name === 'Ultrasound') && <Segmented value="timeline" className='cal-schedule'>Schedule</Segmented>} */}
            </SegmentedGroup>
          </div>
          <div>
            <CalendarPrev className="cal-header-prev" />
            <CalendarToday className="cal-header-today" />
            <CalendarNext className="cal-header-next" />
          </div>
          <div>
            <Button variant='text' onClick={() => {setShowOutofOfficeForm(true);}}><WorkOffIcon sx={{'color': '#E17E61'}}/></Button>
          </div>
        </div>
      </div>
    ),
    [changeView, view, avatars, useTimeline, tabValue, handleAvatarSelection, departmentList],
  );



  const numberToColorHash = useCallback((num: number) => {
    // Use the golden ratio to spread out hue values more evenly
    const goldenRatio = 0.618033988749895; // Golden ratio conjugate
    const hue = (num * goldenRatio * 360) % 360; // Generate hue in the range [0, 360]

    // Convert hue to RGB using HSL model

    return hslToHex(hue, 65, 50); // 65% saturation, 50% lightness
  }, []);



  function hslToHex(h: number, s: number, l: number): string {
    s /= 100;
    l /= 100;

    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs((h / 60) % 2 - 1));
    const m = l - c / 2;
    let r = 0, g = 0, b = 0;

    if (0 <= h && h < 60) {
      r = c; g = x; b = 0;
    } else if (60 <= h && h < 120) {
      r = x; g = c; b = 0;
    } else if (120 <= h && h < 180) {
      r = 0; g = c; b = x;
    } else if (180 <= h && h < 240) {
      r = 0; g = x; b = c;
    } else if (240 <= h && h < 300) {
      r = x; g = 0; b = c;
    } else if (300 <= h && h < 360) {
      r = c; g = 0; b = x;
    }

    // Convert r, g, b from 0–1 to 0–255 and then to hex
    r = Math.round((r + m) * 255);
    g = Math.round((g + m) * 255);
    b = Math.round((b + m) * 255);

    const redHex = r.toString(16).padStart(2, '0');
    const greenHex = g.toString(16).padStart(2, '0');
    const blueHex = b.toString(16).padStart(2, '0');

    return `#${redHex}${greenHex}${blueHex}`;
  }

  useEffect(() => {
    updateStatus();
    // eslint-disable-next-line
  }, [appointments]);

  useEffect(() => {
    updateStatus();
    // eslint-disable-next-line
  }, [selectedDate]);


  // Fetch calendar events from API
  useEffect(() => {
    
    if (query && tabValue) {
      showLoader();
      getAppointments(query, viewDateFrom, viewDateTo).then((appointments) => {
        setAppointments(appointments.objects);
        const events = appointments.objects
          .map((appointment: Appointment) => {
            const msbcEvent: CustomMbscEvent = {
              start: convertToLocalDateTime(appointment?.start_datetime ?? ''),
              end: convertToLocalDateTime(appointment?.end_datetime ?? ''),
              title: view === 'timeline' 
                ? (appointment?.department__name ?? '') 
                : getEventText(appointment ?? {}),
              id: appointment?.id ?? `${Math.random()}`,
              color: view === 'timeline'
                ? numberToColorHash(appointment?.department__id ?? 0)
                : getEventBgColor(appointment?.status ?? ''),
              resource: appointment?.user?.id ?? '',
              status: appointment?.status ?? '',
            };
            return msbcEvent;
          });
        setEvents(events);
      }).catch((error)=> {
        console.log(error);
        addAlert('Error while updating calendar', 'error');
        hideLoader();
      }).finally(() => hideLoader());
    }
    // eslint-disable-next-line 
  }, [showLoader, hideLoader, addAlert, numberToColorHash, query, modelStateUpdate, viewDateFrom, viewDateTo]);


  const handleContextMenu = (e: React.MouseEvent) => {
    e.preventDefault();
  };

  function handleRenderDay(args: MbscCalendarDayData) {
    return <div>{args.date.getDate().toString()}</div>;
  }

  function handleEnventDragEnd(args: MbscEventDragEvent, inst: EventcalendarBase): void {
    showLoader();
    const start = args.event.start as Date;
    const end = args.event.end as Date;
    const id = args.event.id;
    if (id) {
      updateAppointmentDate(id as number, start, end).then((res: any) => {
        addAlert('Schedule updated', 'success');
      }).catch((error: any) => {
        addAlert(error.response.data.errors[0].detail || 'error occured', 'error');
        console.log(error);
      })
        .finally(() => {
          hideLoader();
          setModelStateUpdate(!modelStateUpdate);
        });
    }
  }

  function getFirstAndLastDayOfCurrentMonth(): { firstDay: string; lastDay: string } {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth(); // 0-indexed: Jan is 0
  
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0); // Day 0 of next month = last day of current
  
    const format = (date: Date) =>
      `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(
        date.getDate()
      ).padStart(2, '0')}`;
  
    return {
      firstDay: format(firstDay),
      lastDay: format(lastDay),
    };
  }

  function updateStatus() {
    if (selectedDate) {
      let dateFrom: Date;
      let dateTo: Date;

      if (view === 'day') {
      // For day view, use viewDateTo for both from and to
        dateFrom = new Date(viewDateTo?.toDateString() ?? '');
        dateTo = new Date(viewDateTo?.toDateString() ?? '');
      } else {
      // For other views, use viewDateFrom and viewDateTo
        dateFrom = new Date(viewDateFrom?.toDateString() ?? '');
        dateTo = new Date(viewDateTo?.toDateString() ?? '');
      }

      const formattedDateFrom = dateFrom.toISOString().split('T')[0];
      const formattedDateTo = dateTo.toISOString().split('T')[0];

      getStatus(
        formattedDateFrom ?? selectedDate,
        formattedDateTo ?? selectedDate,
        tabValue?.id?.toString(),
        selectedDoctor?.toString()
      ).then((data: Status[]) => setStatus(data));
    }
  }


  useEffect(() => {
    if(initialLoad){
      setInitialLoad(false);
      // If selectedDate is null, use the first and last day of the current month
      getStatus(getFirstAndLastDayOfCurrentMonth().firstDay, getFirstAndLastDayOfCurrentMonth().lastDay, tabValue?.id?.toString() ?? '2', selectedDoctor?.toString()).then((data: Status[]) => setStatus(data));
    }
    // eslint-disable-next-line 
  },[]);

  function handleDateChange(args: MbscSelectedDateChangeEvent, inst: EventcalendarBase): void {
    const date = formatDateToLocalYYYYMMDD(args.date as Date);
    setSelectedDate(date);
  }

  // Filter the Tabs for the department List to be passed to the appointment modal.
  const getDepartmentTabs = () => departmentList.filter((department: DepartmentDetail) => departmentFilters.includes(department.name) || docFilters.includes(department.name));
  
  function handleEventInit(): void {
    showLoader();
  }

  function handleEventUpdate(): void {
    hideLoader();
  }

  const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,      
      boxShadow: theme.shadows[1],      
    },
  }));

  const getTooltipData = (tooltipText: string) => {
    return (
      <Box bgcolor={'white'} p={1}>
        <Typography variant='body2' color="textSecondary" fontWeight={600}> 
          {tooltipText}
        </Typography>
      </Box>
    );
  };

  useEffect(() => {
    let limit = '100';
    if (view === 'month') {
      limit = '1000';
    } else if (view === 'week') {
      limit = '500';
    } else {
      limit = '100';
    }
    if (filterAppointments !== undefined && tabValue?.id) {
      setQuery(`limit=${limit}&order_by=end_datetime&department__id=${tabValue?.id}&status=${filterAppointments}`);
    }
  }, [filterAppointments, tabValue?.id, view]);

  useEffect(() => {    
    if(ClinicId && tabValue &&viewDateFrom && viewDateTo){
      getAppointmentsOOO({
        clinic_id: ClinicId,
        appointment_date_after: viewDateFrom ? formatDateToDDMMYYYY(viewDateFrom) : undefined,
        appointment_date_before: viewDateTo ? formatDateToDDMMYYYY(viewDateTo) : undefined
      }).then((appointments) => {
        const oooEvents = appointments.objects.filter((appointments: Appointment) => appointments.status !== 'CANCELLED')
          .map((appointment: Appointment) => {
            const msbcEvent: CustomMbscEvent = {
              start: convertToLocalDateTime(appointment.start_datetime),
              end: convertToLocalDateTime(appointment.end_datetime),
              title: `${appointment.user.first_name} ${appointment.user.last_name} - Unavailable`,
              order: 1,
              id: appointment.id,
              color: '#47494a',
              resource: appointment.user.id,
              status: appointment.status,
              text: appointment.remark,
              tooltip: appointment.remark,
              dragBetweenResources: false,
              dragBetweenSlots: false,
              dragInTime: false,
              cssClass: 'cal-ooo-events',
              overlap: true,
              category: 'OUT_OF_OFFICE',
              
            };
            return msbcEvent;
          });
        setOooEvents(oooEvents);
      });
    }
  }, [ClinicId, modelStateUpdate, tabValue, viewDateFrom, viewDateTo]);

  return (
    <>
      {showOutofOfficeForm && <OutOfOfficeForm open={showOutofOfficeForm} handleClose={handleClosehowOutofOfficeFormModel}/>}
      <CustomModal
        isOpen={openViewModel}
        onClose={handleCloseViewModel}
        id={viewEvent?.event.id as number}
      />
      <AppointmentModal open={openCreateModel} onClose={handleCloseCreateModel} resource={createEvent?.event.resource?.toString()} slotDate={createEvent?.event?.start as Date || undefined} slotDepartment={tabValue?.id} departmentName={tabValue?.name} departmentTabs={getDepartmentTabs()}handleTabChange={setTabValue}/>
      <div className={'cal-tabs-sec'}>
        <div className='cal-deps'>
          {view !== 'timeline' &&
            <><ButtonGroup sx={{
              borderRadius: '2rem',
              height: 'fit-content',
              display: 'flex',
              gap: '5px', // Add gap between buttons
              '& .MuiButton-root': {
                border: 'none',
              },
              '& .MuiButton-root:hover': {
                backgroundColor: 'transparent', // Ensure hover doesn't add background color
              },
            }} variant="outlined" color='secondary' aria-label="Basic button group">
              {departmentList && departmentList.filter((department: DepartmentDetail) => departmentFilters.includes(department.name))
                .map((department: DepartmentDetail) => (<Button sx={{
                  color: tabValue?.id === department.id ? '#E17E61' : 'inherit',
                  fontFamily: 'nunito',
                  fontWeight: tabValue?.id === department.id ? 900 : 500,
                  fontSize: '1rem',
                  border: '1px solid black',
                  height: '2rem'
                }} key={department.id} onClick={() => { setTabValue(department); } }>{department.name}</Button>))}
            </ButtonGroup><Divider orientation="vertical" flexItem /></>
          }
          {view !== 'timeline' && <ButtonGroup sx={{
            borderRadius: '2rem',
            height: 'fit-content',
            display: 'flex',
            gap: '5px', // Add gap between buttons
            '& .MuiButton-root': {
              border: 'none',
            },
            '& .MuiButton-root:hover': {
              backgroundColor: 'transparent', // Ensure hover doesn't add background color
            },
          }} variant="outlined" color='secondary' aria-label="Basic button group">
            {departmentList && departmentList.filter((department: DepartmentDetail) => docFilters.includes(department.name))
              .map((department: DepartmentDetail) => (<Button sx={{
                color: tabValue?.id===department.id ? '#E17E61' : 'inherit',
                fontFamily: 'nunito',
                fontWeight: tabValue?.id===department.id ? 900: 500,
                fontSize: '1rem',
                border: '1px solid black',
                height: '2rem'
              }} key={department.id} onClick={()=>{setTabValue(department);}}>{department.name}</Button>))}
          </ButtonGroup>}
        </div>
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center',  }}>
          <LightTooltip placement={'left-end'} title={currentView ==='CALENDAR' ? null : getTooltipData('Calendar View')}>
            <Typography component={'span'}>
              <IconButton disabled={currentView==='CALENDAR'} onClick={()=>{setCurrentView('CALENDAR');}}>
                <CalendarViewMonthIcon/>
              </IconButton>
            </Typography>
          </LightTooltip>
          <LightTooltip placement={'left-end'} title={currentView ==='TABLE' ? null : getTooltipData('Timeline View')}>
            <Typography component={'span'}>
              <IconButton disabled={currentView==='TABLE'} onClick={()=>{setCurrentView('TABLE');}}>
                <ListIcon/>
              </IconButton>
            </Typography>
          </LightTooltip>
        </Stack>
      </div>
      {currentView === 'CALENDAR' ? <div onClick={closeMenu} onContextMenu={handleContextMenu} className='table-parent'>
        <Suspense fallback={<CalendarComponent/>}>
          <Eventcalendar
            onPageLoaded={handlePageLoad}
            onPageChange={handlePageLoad}
            onEventUpdate={handleEventUpdate}
            onInit={handleEventInit}
            onSelectedDateChange={handleDateChange}
            renderScheduleEventContent={renderEvent}
            renderLabelContent={renderEvent}
            clickToCreate={true}
            dragToCreate={false}
            dragToMove={false}
            dragToResize={false}
            eventDelete={true}
            renderHeader={customWithNavButtons}
            height={'80vh'}
            width={'100%'}
            view={calView}
            onCellDoubleClick={(event: MbscCellClickEvent) => {
              event.domEvent.preventDefault();
              event.domEvent.stopPropagation();
            }}
            {...(useTimeline ? { data: filterAppointmentsScheduled==='Unavailable' ? [...oooEvents] : filterAppointmentsScheduled ? [...myEvents.filter((event: MbscCalendarEvent) => event?.title?.includes(filterAppointmentsScheduled))]:
              [...myEvents, ...oooEvents] } : { data: myEvents })}
            cssClass="md-switching-view-cont"
            onEventRightClick={handleEventRightClick}
            onEventDragEnd={handleEnventDragEnd}
            {...(useTimeline && { resources: resource })}
            {...(useTimeline && { renderResource: renderCustomResource })}
            onEventCreate={(event: MbscEventCreateEvent) => {
              setCreateEvent(event);
              handleOpenCreateModel(event);
            } }
            onEventClick={(event: MbscEventClickEvent) => {
              if (event.event.title?.includes('Out of Office') || event.event.category === 'OUT_OF_OFFICE') {
                return;
              }

              setViewEvent(event);
              handleOpenViewModel();
            } }
            // Disable or grey out past dates so users can't book slots for previous dates
            invalid={[
              {
                start: new Date(0),                        // Start from the earliest date possible
                end: new Date(new Date().setDate(new Date().getDate())),  // Disable up to yesterday
              }
            ]}
          />
          {view !== 'timeline' ? 
            <div className='calFooter'>
              <Stack direction="row" spacing={1}>
                {status && status.map((st: Status, index: number) => (
                  <Chip 
                    key={st?.status}
                    label={`${st?.status.replace('_', ' ')}: ${st?.count}`}
                    variant={filterAppointments === st?.status ? 'filled' : 'outlined'} 
                    onClick={() => {setFilterAppointments(st?.status);}}
                    sx={{opacity: filterAppointments === st?.status ? 1 : 0.8, backgroundColor: getStatusColor(st.status), border: filterAppointments === st?.status ? `1px solid ${getEventBgColor(st?.status)}` : 'none', color: getEventBgColor(st?.status)}}
                  />
                ))}
              </Stack>
              {filterAppointments && <Button onClick={()=>{setFilterAppointments('');}}>Reset</Button>}
            </div> :
            <div className='calFooter'>
              {scheduleFilters.map((filter: string, index: number) => (
                <Chip 
                  key={filter}
                  label={filter}
                  variant={filter===filterAppointmentsScheduled?.toLocaleUpperCase() ? 'filled' : 'outlined'} 
                  onClick={() => {setFilterAppointmentsScheduled(toTitleCase(filter));}}
                
                  style={{fillOpacity: 1,  opacity: filter===filterAppointmentsScheduled?.toLocaleUpperCase() ? 1 : 0.6, backgroundColor: getDepartmentColor(filter), border: filter===filterAppointmentsScheduled?.toLocaleUpperCase() ? `1px solid ${getEventBgColor(filter)}` : 'none', color:  '#fff', fontWeight:600}}
                />
              ))}            
              {filterAppointmentsScheduled && <Button onClick={()=>{setFilterAppointmentsScheduled('');}}>Reset</Button>}
            </div>}
        </Suspense>

        {/* Material-UI Dropdown Menu */}
        <Menu
          open={Boolean(menuPosition)}
          onClose={closeMenu}
          anchorReference="anchorPosition" // Use anchorPosition to position based on mouse click
          anchorPosition={menuPosition ? { top: menuPosition.mouseY, left: menuPosition.mouseX } : undefined} // Menu opens at the cursor
        >
          <MenuItem onClick={() => {
            if (clickedEvent?.id) {
              showLoader();
              cancelAppointmentOOO(clickedEvent?.id as number)
                .catch(() => addAlert('Failed to cancel event', 'error'))
                .finally(() => {
                  setModelStateUpdate(!modelStateUpdate);
                  hideLoader();
                });
            }

            closeMenu();
          } }>Cancel Event</MenuItem>
          <MenuItem onClick={() => {
            closeMenu();
          } }>Close</MenuItem>
        </Menu>
      </div>:   <AppointmentTable departmentID={tabValue?.id} departmentName={tabValue?.name} departmentTabs={getDepartmentTabs()} handleTabChange={setTabValue}/>}      
    </>
  );
};
export default CalendarComponent;

function getEventText(appointment: Appointment): string {
  if (appointment.department__name && appointment.department__name.toUpperCase() === 'ADMIN') {
    return `Pt-${appointment.patient?.first_name} Ad-${appointment?.user?.first_name ?? ''}--${appointment?.status}`;
  }
  if (appointment.department__name && appointment.department__name.toUpperCase() === 'PATHOLOGY') {
    return `Pt-${appointment.patient?.first_name} Pb-${appointment?.user?.first_name ?? ''}--${appointment?.status}`;
  }
  if (appointment.department__name && appointment.department__name.toUpperCase() === 'SEMEN COLLECTION') {
    return `Pt-${appointment.patient?.first_name}--${appointment?.status}`;
  }
  return `Pt-${appointment.patient?.first_name} Dr-${appointment?.user?.first_name ?? ''}--${appointment?.status}`;
}
